import { useEffect, Suspense, lazy } from 'react';
import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import TagManager from 'react-gtm-module';
const Homepage = lazy(() => import('./homepage/Homepage'));
import Navbar from './dashboard/top-navbar/Navbar';
import PrivateRoute from './shared/private-route/PrivateRoute';
const Dashboard = lazy(() => import('./dashboard/Dashboard'));
const LandingPage = lazy(() => import('./landing-page/LandingPage'));
const EmailActionHandler = lazy(() => import('./register/email-action-handler/EmailActionHandler'));
const ProcessingPage = lazy(() => import('./dashboard/processing-page/ProcessingPage'));
import Spinner from './shared/spinner/Spinner';
import UploadBlockingOverlay from './shared/upload-blocking-overlay/UploadBlockingOverlay';
import { Toaster } from 'react-hot-toast';
import { useStoreActions } from 'easy-peasy';
import { setCurrentProjectId } from './homepage/current-slide/renderers/resources/imageCache';
import { setCurrentProjectId as setFontProjectId } from './homepage/current-slide/renderers/resources/fontCache';
import PricingPage from './pricing-page/PricingPage';

function AuthInit() {
  const initAuthListener = useStoreActions((actions) => actions.auth.initAuthListener);
  useEffect(() => {
    initAuthListener();
  }, [initAuthListener]);
  return null;
}

function App() {
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('projectId');

  useEffect(() => {
    // Initialize Google Tag Manager
    TagManager.initialize({
      gtmId: 'GTM-PZZKL9V3'
    });
  }, []);

  useEffect(() => {
    if (projectId) {
      setCurrentProjectId(projectId);
      setFontProjectId(projectId);
    }
  }, [projectId]);
  return (
    <>
      <AuthInit />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            borderRadius: '10px',
            background: '#222',
            color: '#fff',
            fontWeight: 500,
            fontSize: '1rem',
            boxShadow: '0 4px 32px rgba(0,0,0,0.12)'
          }
        }}
      />
      <UploadBlockingOverlay />

      <Suspense fallback={<Spinner />}>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/signin" element={<LandingPage />} />
          <Route path="/auth/action" element={<EmailActionHandler />} />
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/processing/:projectId"
            element={
              <PrivateRoute>
                <ProcessingPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/projects/:projectId"
            element={
              <PrivateRoute>
                <div style={{ marginTop: '64px' }}>
                  <Navbar />
                  <Homepage />
                </div>
              </PrivateRoute>
            }
          />
          <Route
            path="/pricing"
            element={
              <PrivateRoute>
                <PricingPage />
              </PrivateRoute>
            }
          />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
